import { render } from "./AboutOffer.vue?vue&type=template&id=7b4a437e"
import script from "./AboutOffer.vue?vue&type=script&lang=js"
export * from "./AboutOffer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__